'use client'

import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import { Box } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import Icon14CheckCircle from 'src/assets/icons/Icon14CheckCircle'

interface PollResultBarProps {
	title: string
	voted: string
	percent: number
	isTop?: boolean
	isUserVoted?: boolean
}
const PollResultBar = ({ title, voted, percent, isTop, isUserVoted }: PollResultBarProps) => {
	return (
		<UIFlex
			sx={{
				'&>*:not(:first-child)': {
					marginTop: pxToRem(4),
				},
			}}
		>
			<UIFlex flexDirection="row" justifyContent="space-between" alignItems="center">
				<UIText
					fontSize={pxToRem(14)}
					lineHeight={pxToRem(22)}
					fontWeight={600}
					color={isTop ? color.colDarkBlue : color.colBlack}
					display="flex"
					alignItems="center"
					sx={{
						'&>*:not(:first-child)': {
							marginLeft: pxToRem(4),
						},
					}}
				>
					{title}
					{isUserVoted && <Icon14CheckCircle />}
				</UIText>
				<UIText
					minWidth={pxToRem(48)}
					fontSize={pxToRem(13)}
					lineHeight={pxToRem(22)}
					fontWeight={500}
					color={color.colGray4}
					textAlign="right"
				>
					{voted}
				</UIText>
			</UIFlex>
			<UIFlex
				flexDirection="row"
				alignItems="center"
				sx={{
					'&>*:not(:first-child)': {
						marginLeft: pxToRem(16),
					},
				}}
			>
				<Box
					flexGrow={1}
					height={pxToRem(8)}
					borderRadius="9999px"
					bgcolor={color.colGray2}
					overflow="hidden"
				>
					<Box
						height={pxToRem(8)}
						borderRadius="9999px"
						bgcolor={isTop ? color.colDarkBlue : color.colGray4}
						width={`${percent}%`}
					/>
				</Box>
				<UIText
					minWidth={pxToRem(36)}
					fontSize={pxToRem(13)}
					lineHeight={pxToRem(22)}
					fontWeight={600}
					color={isTop ? color.colDarkBlue : color.colGray5}
					textAlign="right"
				>
					{percent}%
				</UIText>
			</UIFlex>
		</UIFlex>
	)
}

export default PollResultBar
